export class UserIdResults {
    AlertGroupName?: string;
    AlertGroupAbbreviation?: string;
    AlertGroupDescription?: string;
    AlertGroupDisplaySortOrder?: string;
    AlertGroupId?: number;
    AlertID?: number;
    AlertTypeCode?: string;
    AlertTypeDescription?: string;
    DateActive?: string;
    AlertStatusCode?: string;
    AlertDetail?: string;
    DayCount?: number;
    row?: number;
}
export class AlertResults {
    AlertGroupId?: number;
    AlertGroupName?: string;
    AlertGroupAbbreviation?: string;
    AlertGroupDescription?: string;
    AlertGroupDisplaySortOrder?: number;
    
}


